import React, { useState, useEffect, useContext } from 'react'
import {
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Grid,
  InputAdornment,
  Typography,
} from '@mui/material'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { Edit, Delete, DragHandle, Star, StarBorder } from '@mui/icons-material'

const UserGoals = ({
  intakeState,
  updateIntakeStateAndSubmit,
  updateIntakeStateAtKey,
}) => {
  const [goals, setGoals] = useState(intakeState.userGoals || [])

  useEffect(() => {
    setGoals(intakeState.userGoals || [])
  }, [intakeState.userGoals])

  const [newGoal, setNewGoal] = useState('')
  const [editIndex, setEditIndex] = useState(null)
  const [editText, setEditText] = useState('')
  const [open, setOpen] = useState(false)

  const updateGoals = (updatedGoals) => {
    setGoals(updatedGoals)
    console.log(updatedGoals)
    updateIntakeStateAndSubmit(() =>
      updateIntakeStateAtKey({ userGoals: updatedGoals })
    )()
  }

  const handleAddGoal = () => {
    if (newGoal.trim() === '') return
    updateGoals([...goals, { text: newGoal, starred: false }])
    setNewGoal('')
  }

  const handleDeleteGoal = (index) => {
    updateGoals(goals.filter((_, i) => i !== index))
  }

  const handleEditGoal = (index) => {
    setEditIndex(index)
    setEditText(goals[index].text)
    setOpen(true)
  }

  const handleSaveEdit = () => {
    const updatedGoals = [...goals]
    updatedGoals[editIndex].text = editText
    updateGoals(updatedGoals)
    setOpen(false)
  }

  const toggleStarred = (index) => {
    const updatedGoals = [...goals]
    updatedGoals[index].starred = !updatedGoals[index].starred
    updateGoals(updatedGoals)
  }

  const onDragEnd = (result) => {
    if (!result.destination) return
    const reorderedGoals = Array.from(goals)
    const [movedGoal] = reorderedGoals.splice(result.source.index, 1)
    reorderedGoals.splice(result.destination.index, 0, movedGoal)
    updateGoals(reorderedGoals)
  }

  return (
    <Box>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="goals">
          {(provided) => (
            <>
              {goals.length > 0 ? (
                <List
                  sx={{ border: '1px solid #ddd', borderRadius: '8px' }}
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {goals.map((task, index) => (
                    <Draggable
                      key={index}
                      draggableId={String(index)}
                      index={index}
                    >
                      {(provided) => (
                        <ListItem
                          sx={{
                            borderBottom: '1px solid #ddd',
                            padding: '4px 48px 4px 4px',
                            '&:last-of-type': {
                              borderBottom: 'none',
                            },
                            '&>span>svg': {
                              marginBottom: '-3px',
                            },
                          }}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          secondaryAction={
                            <>
                              <IconButton onClick={() => handleEditGoal(index)}>
                                <Edit />
                              </IconButton>
                              <IconButton onClick={() => toggleStarred(index)}>
                                {task.starred ? <Star /> : <StarBorder />}
                              </IconButton>
                              <IconButton
                                onClick={() => handleDeleteGoal(index)}
                              >
                                <Delete />
                              </IconButton>
                            </>
                          }
                        >
                          <span
                            {...provided.dragHandleProps}
                            style={{ cursor: 'grab', marginRight: '10px' }}
                          >
                            <DragHandle />
                          </span>
                          <ListItemText primary={task.text} />
                        </ListItem>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </List>
              ) : (
                <Typography variant="body2">
                  No Client Goals. Please add below:
                </Typography>
              )}
            </>
          )}
        </Droppable>
      </DragDropContext>
      <Grid container columnSpacing={3} mt={1}>
        <Grid item xs={12}>
          <TextField
            placeholder="Add a Client Goal"
            fullWidth
            variant="outlined"
            value={newGoal}
            onChange={(e) => setNewGoal(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault() // Prevent form submission
                handleAddGoal()
              }
            }}
            sx={{ marginBottom: '16px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Button
                    variant="contained"
                    sx={{
                      fontSize: '15px',
                      padding: '10px 24px 9px',
                      backgroundColor: '#344767',
                      color: '#fff',
                      fontWeight: 'normal',
                      boxShadow: 'none',
                      borderRadius: '0px 8px 8px 0px',
                      position: 'absolute',
                      top: -1,
                      right: 0,
                      '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                        transform: 'none',
                        backgroundColor: '#293852',
                        boxShadow: 'none',
                      },
                    }}
                    onClick={handleAddGoal}
                  >
                    Add +
                  </Button>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Edit Goal</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            value={editText}
            onChange={(e) => setEditText(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleSaveEdit} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default UserGoals
